// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FavoriteIcons__wrap__e624c2ce","iconWrap":"FavoriteIcons__iconWrap__e624c2ce","icon":"FavoriteIcons__icon__e624c2ce"};